import { NoonReportSectionEnum, SectionRoleEnum } from './AolEnums';

export class NoonReportSectionData {
    noonReportId?: number;
    section: NoonReportSectionEnum;
    isCompleted: boolean;
    isApproved: boolean;
    role: SectionRoleEnum;

    constructor(noonReportId: number, section: NoonReportSectionEnum, isCompleted: boolean, isApproved: boolean, role: SectionRoleEnum) {
        this.noonReportId = noonReportId;
        this.section = section;
        this.isCompleted = isCompleted;
        this.isApproved = isApproved;
        this.role = role;
    }
}
